const common = {
  // Nav
  "nav.guides": "Home",
  "nav.clientSdk": "Features",
  "nav.serverApi": "Docs",
  "nav.download": "Download",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "PC",
  "nav.github": "GitHub",
  "nav.blog": "Blog",

  // Hero
  "hero.badge": "Open Source Messaging",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIM is an open-source instant messaging component by IM technology experts — including IM server and client SDK. Lightweight, flexible, and easy to extend. Deploy privately and keep your data secure.",
  "hero.download": "Download",
  "hero.stat.devs": "Developers",
  "hero.stat.msgs": "Messages/day",
  "hero.badge2.title": "End-to-End Encrypted",
  "hero.badge2.desc": "Your messages stay private",

  // Features
  "features.label": "Core Features",
  "features.title": "Everything you need to communicate",
  "features.subtitle": "TupIM delivers a complete instant messaging solution — messages, calls, groups, files, and more. All in one platform.",

  "feat.msg.title": "Instant Messaging",
  "feat.msg.desc": "Text, emoji, images, voice, and video messages with millisecond-level delivery.",
  "feat.call.title": "Audio & Video Calls",
  "feat.call.desc": "Crystal-clear one-on-one or group calls, with screen sharing support.",
  "feat.group.title": "Group Chat",
  "feat.group.desc": "Create and manage groups supporting thousands of members with full admin controls.",
  "feat.file.title": "File Transfer",
  "feat.file.desc": "Fast and secure transfer of files, photos, and videos with resume support.",
  "feat.encrypt.title": "End-to-End Encryption",
  "feat.encrypt.desc": "All messages are E2E encrypted. Private keys stay on your device only.",
  "feat.notify.title": "Push Notifications",
  "feat.notify.desc": "Instant push across all platforms — never miss an important message.",
  "feat.cross.title": "PC+APP Support",
  "feat.cross.desc": "One SDK covers Web, Android, and iOS.",
  "feat.private.title": "Private Deployment",
  "feat.private.desc": "Deploy on your own server. You own your data. Enterprise-grade security.",
  "feat.selfhost.title": "High Performance",
  "feat.selfhost.desc": "Built with Go. Single node supports millions of concurrent connections.",

  "features.sdk.title": "Multi-Platform SDK Support",
  "features.sdk.desc": "Whatever your tech stack, TupIM has an SDK ready for you",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIM is an open-source instant messaging component by IM technology experts — including IM server and client SDK. Lightweight, flexible, and easy to extend. Deploy privately and keep your data secure.",
  "api.hero.btn.start": "Start Building",
  "api.hero.btn.guide": "Getting Started",

  // Api / Deploy section
  "api.open.title": "Fully Open Source",
  "api.open.desc": "TupIM server and all SDKs are open-sourced on GitHub under MIT license — free to use, modify, and distribute.",
  "api.open.contrib": "Contributors",
  "api.open.btn": "View on GitHub",
  "api.deploy.title": "Self-Host with Ease",
  "api.deploy.desc": "Deploy TupIM on your own server in minutes. No third-party dependencies — your data stays yours.",
  "api.deploy.f1": "One-click deploy with Docker Compose",
  "api.deploy.f2": "Kubernetes cluster deployment support",
  "api.deploy.f3": "Full monitoring and logging system",
  "api.deploy.btn": "Read Deployment Docs",

  // Help
  "help.title": "What can we help you with?",
  "help.demo.title": "Check Demo",
  "help.demo.desc": "You can go to download Apps for user testing or visit the demo website.",
  "help.demo.link": "Go now →",
  "help.support.title": "Support",
  "help.support.desc": "You can find or submit related issues in TupIM's code repository.",
  "help.support.link": "Go now →",
  "help.faq.title": "FAQ",
  "help.faq.desc": "Browse our FAQ section to find answers to common questions.",
  "help.faq.link": "View FAQ →",

  // Community
  "community.title": "Join the Community",
  "community.desc": "Engage with our growing community for the latest updates, product support, and more.",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "Android App",
  "download.android.title": "Download TupIM for Android",
  "download.android.desc": "A fully-featured instant messaging Android app with text, voice, video calls, group chats, file transfers, and much more.",
  "download.android.version": "Latest Version",
  "download.android.size": "Package Size",
  "download.android.require": "Requirements",
  "download.android.require.val": "Android 5.0 and above",
  "download.android.btn": "Download APK",
  "download.android.qr": "Scan to Download",
  "download.android.qr.desc": "Use your phone camera or QR scanner to scan",
  "download.android.tip": "After downloading, allow installation from unknown sources if prompted",
  "download.android.cta.title": "Get Started Now",
  "download.android.cta.desc": "Free download — start experiencing secure, high-performance instant messaging",

  "download.ios.badge": "iOS App",
  "download.ios.title": "Download TupIM for iOS",
  "download.ios.desc": "An instant messaging app built for iPhone and iPad, delivering a smooth native experience with all core communication features.",
  "download.ios.version": "Latest Version",
  "download.ios.size": "Package Size",
  "download.ios.require": "Requirements",
  "download.ios.require.val": "iOS 13.0 and above",
  "download.ios.btn": "Download on App Store",
  "download.ios.btn2": "TestFlight Beta",
  "download.ios.qr": "Scan to Download",
  "download.ios.qr.desc": "Use iPhone camera to scan and go to App Store",
  "download.ios.tip": "Supports iPhone and iPad running iOS 15.0 or later",
  "download.ios.cta.title": "Get Started Now",
  "download.ios.cta.desc": "Download for free on App Store, or join TestFlight to experience the latest features early",

  // PC Download
  "download.pc.badge": "Desktop App",
  "download.pc.title": "Download TupIM for Desktop",
  "download.pc.desc": "A full-featured instant messaging desktop client for Windows, macOS, and Linux. Enjoy a larger screen experience with all core communication features.",
  "download.pc.btn.windows": "Download for Windows",
  "download.pc.btn.mac": "Download for macOS",
  "download.pc.btn.open": "Open in Browser",
  "download.pc.cta.btn": "Open Web App",
  "download.pc.browser.support": "Supported Browsers",

  "download.pc.tip": "Free · No installation needed. Syncs with all your devices.",
  "download.pc.features.title": "Core Features",
  "download.pc.features.subtitle": "Everything you need for productive team communication on desktop",
  "download.pc.screenshots.title": "App Screenshots",
  "download.pc.ss.chats": "Chats",
  "download.pc.ss.call": "Video Call",
  "download.pc.ss.group": "Group Chat",
  "download.pc.ss.file": "File Manager",
  "download.pc.cta.title": "Get Started on Desktop",
  "download.pc.cta.desc": "Free download for all platforms — sync across mobile and desktop seamlessly",

  // Download features
  "download.feature.msg": "Instant Messaging",
  "download.feature.msg.desc": "Support text, emoji, image, voice, video and other message types",
  "download.feature.call": "Audio/Video Call",
  "download.feature.call.desc": "One-on-one or group audio/video calls, clear and smooth",
  "download.feature.group": "Group Chat",
  "download.feature.group.desc": "Create and manage groups, supporting thousands of members",
  "download.feature.file": "File Transfer",
  "download.feature.file.desc": "Fast and secure file, photo and video transfer",
  "download.feature.encrypt": "End-to-End Encryption",
  "download.feature.encrypt.desc": "All messages are end-to-end encrypted for privacy",
  "download.feature.notify": "Push Notifications",
  "download.feature.notify.desc": "Instant push for important messages, never miss one",
  "download.feature.shortcut": "Keyboard Shortcuts",
  "download.feature.shortcut.desc": "Boost productivity with rich keyboard shortcuts and quick actions on desktop",

  // Download Section (homepage)
  "dl.label": "Download",
  "dl.title": "Multi-Platform Download",
  "dl.subtitle": "Available on Android, iOS, and all major desktop platforms. Your messages sync seamlessly across every device.",
  "dl.sync": "All versions are free. Data syncs in real-time across all your devices.",
  "dl.android.title": "Android",
  "dl.android.desc": "Full-featured messaging app for Android phones and tablets. Supports text, voice, video calls, group chats and more.",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "Download for Android",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "Native iOS experience built for iPhone and iPad. Smooth, fast, and beautifully designed for Apple devices.",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "Download for iOS",
  "dl.pc.title": "Desktop",
  "dl.pc.desc": "Powerful desktop client for Windows and macOS. Enjoy a larger screen with enhanced productivity features.",
  "dl.pc.req": "Win / Mac",
  "dl.pc.btn": "Download for Desktop",

  // Showcase
  "showcase.label": "Deep Dive",
  "showcase.title": "Every feature, crafted for you",
  "showcase.subtitle": "From instant messaging to video calls, every module is finely polished to deliver the smoothest communication experience.",

  "showcase.msg.title": "Instant Messaging",
  "showcase.msg.tag": "Messaging",
  "showcase.msg.desc": "Millisecond-level delivery with support for all rich media message types",
  "showcase.msg.p1": "Supports 20+ message types: text, emoji, image, voice, video, files and more",
  "showcase.msg.p2": "Read receipts visible to both parties — see who's read your messages",
  "showcase.msg.p3": "Message recall, quote replies, and @mention support",
  "showcase.msg.p4": "Offline messages sync automatically — never miss a conversation",

  "showcase.call.title": "Audio & Video Calls",
  "showcase.call.tag": "Calling",
  "showcase.call.desc": "Crystal-clear HD calls that stay stable even on weak networks",
  "showcase.call.p1": "Supports one-on-one and multi-party group audio/video calls",
  "showcase.call.p2": "Built-in screen sharing for effortless collaboration",
  "showcase.call.p3": "Adaptive bitrate keeps calls smooth on any network condition",
  "showcase.call.p4": "Call recording so you can replay important discussions anytime",

  "showcase.group.title": "Group Chat",
  "showcase.group.tag": "Groups",
  "showcase.group.desc": "Flexible and powerful group management supporting thousands of members",
  "showcase.group.p1": "Single group supports up to 1,000 members",
  "showcase.group.p2": "Multi-level admin roles with fine-grained permission controls",
  "showcase.group.p3": "Group announcements, shared files, and group albums all built-in",
  "showcase.group.p4": "Mute, kick, and join approval for full group moderation",

  "showcase.security.title": "End-to-End Encryption",
  "showcase.security.tag": "Privacy",
  "showcase.security.desc": "E2E encryption — private keys never leave your device",
  "showcase.security.p1": "All messages are fully E2E encrypted — servers cannot read them",
  "showcase.security.p2": "Burn-after-reading support — messages auto-delete once read",
  "showcase.security.p3": "Self-hosted deployment — your data lives on your own servers",
  "showcase.security.p4": "Regular third-party security audits to keep the platform safe",

  // Pricing
  "pricing.label": "Pricing Plans",
  "pricing.title": "Choose the right plan for you",
  "pricing.subtitle": "Whether you're an indie developer, a growing team, or a large enterprise — TupIM has the right plan for every scale.",
  "pricing.popular": "Most Popular",
  "pricing.includes": "What's included",
  "pricing.note": "All plans include a 7-day free trial, no credit card required. Need a custom plan? Talk to our sales team.",

  "pricing.starter.name": "Starter",
  "pricing.starter.tag": "Personal / Small Teams",
  "pricing.starter.desc": "Perfect for individual developers and small apps to explore TupIM's core communication capabilities.",
  "pricing.starter.cta": "Start for Free",
  "pricing.starter.f1": "Up to 500 active users",
  "pricing.starter.f2": "Text, image & voice messages",
  "pricing.starter.f3": "One-on-one audio & video calls",
  "pricing.starter.f4": "Basic groups (up to 50 members)",
  "pricing.starter.f5": "Community technical support",
  "pricing.starter.m1": "Multi-party group calls",
  "pricing.starter.m2": "Private deployment",
  "pricing.starter.m3": "Dedicated technical support",

  "pricing.pro.name": "Pro",
  "pricing.pro.tag": "Growing Teams",
  "pricing.pro.desc": "Built for fast-growing products and teams. Unlock the full feature set to handle millions of users with ease.",
  "pricing.pro.cta": "Contact Sales",
  "pricing.pro.f1": "Up to 10,000 active users",
  "pricing.pro.f2": "All rich media message types",
  "pricing.pro.f3": "Multi-party group audio & video calls",
  "pricing.pro.f4": "Groups up to 1,000 members",
  "pricing.pro.f5": "Screen sharing & call recording",
  "pricing.pro.f6": "End-to-end encryption & burn-after-read",
  "pricing.pro.m1": "Private deployment",

  "pricing.enterprise.name": "Enterprise",
  "pricing.enterprise.tag": "Large Enterprises",
  "pricing.enterprise.desc": "Designed for massive-scale applications and enterprise needs. Fully self-hosted, with complete data ownership.",
  "pricing.enterprise.cta": "Get a Quote",
  "pricing.enterprise.f1": "Unlimited active users",
  "pricing.enterprise.f2": "All features, no limits",
  "pricing.enterprise.f3": "Private deployment & source code license",
  "pricing.enterprise.f4": "Kubernetes cluster high availability",
  "pricing.enterprise.f5": "SLA 99.99% uptime guarantee",
  "pricing.enterprise.f6": "Dedicated technical consultant",
  "pricing.enterprise.f7": "Custom feature development",

  // Docs page
  "docs.title": "Docs",
  "docs.group.start": "Getting Started",
  "docs.group.core": "Core Features",
  "docs.group.dev": "Developer Guide",
  "docs.nav.introduction": "Introduction",
  "docs.nav.quickstart": "Quick Start",
  "docs.nav.messaging": "Instant Messaging",
  "docs.nav.calls": "Audio & Video Calls",
  "docs.nav.groups": "Group Management",
  "docs.nav.encryption": "Security & Encryption",
  "docs.nav.sdk": "SDK Integration",
  "docs.nav.deployment": "Self-Hosting",
  "docs.nav.api": "API Reference",
  "docs.toc": "Contents",
  "docs.copied": "Copied",
  "docs.copy": "Copy",
  "docs.install": "Installation",
  "docs.init": "Initialization",

  // Docs - Server group
  "docs.group.server": "Server",
  "docs.nav.sfu": "SFU Bandwidth Calculation",
  "docs.sfu.title": "How to Calculate Bandwidth for SFU-based Video Conferencing",
  "docs.sfu.intro": "In SFU (Selective Forwarding Unit) architecture, each participant uploads their own stream to the SFU server, and the server selectively forwards streams from other participants. This document explains how to estimate bandwidth requirements for SFU-based video conferencing.",
  "docs.sfu.arch.title": "SFU Architecture Overview",
  "docs.sfu.arch.desc": "Unlike MCU (Multipoint Control Unit), SFU does not mix streams. Each participant maintains N-1 downlink streams (receiving from all other participants) and 1 uplink stream (sending their own). This makes SFU highly scalable and suitable for large group calls.",
  "docs.sfu.formula.title": "Bandwidth Calculation Formula",
  "docs.sfu.formula.uplink": "Uplink (per user): 1 video stream upload",
  "docs.sfu.formula.downlink": "Downlink (per user): (N-1) video streams download",
  "docs.sfu.formula.total": "Total server bandwidth = N × uplink bitrate + N × (N-1) × downlink bitrate",
  "docs.sfu.params.title": "Reference Bitrate Parameters",
  "docs.sfu.params.hd": "HD (720p): ~1.5 Mbps uplink / ~1.2 Mbps downlink",
  "docs.sfu.params.sd": "SD (480p): ~0.8 Mbps uplink / ~0.6 Mbps downlink",
  "docs.sfu.params.ld": "Low (240p): ~0.3 Mbps uplink / ~0.25 Mbps downlink",
  "docs.sfu.example.title": "Calculation Examples",
  "docs.sfu.example.desc": "The following examples assume HD quality (720p) with 1.5 Mbps uplink and 1.2 Mbps downlink per participant.",
  "docs.sfu.note.title": "Important Notes",
  "docs.sfu.note.1": "Add ~20% overhead for protocol headers, retransmission, and RTCP control traffic.",
  "docs.sfu.note.2": "Enable simulcast to allow the SFU to adaptively select stream quality per receiver.",
  "docs.sfu.note.3": "Audio streams typically add 50–100 kbps per participant and should be counted separately.",
  "docs.sfu.note.4": "Screen sharing streams may require 2–4 Mbps additional uplink bandwidth.",

  // Footer
  "footer.tagline": "TupIM\u00a0Comprehensive privacy protection with private chat, group chat, secure messages & more",
  "footer.col.product": "Product",
  "footer.col.developer": "Developers",
  "footer.col.company": "Company",
  "footer.link.features": "Features",
  "footer.link.download": "Download",
  "footer.link.changelog": "Changelog",
  "footer.link.docs": "Documentation",
  "footer.link.api": "API Reference",
  "footer.link.github": "GitHub",
  "footer.link.about": "About",
  "footer.link.blog": "Blog",
  "footer.link.contact": "Contact",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "About Us",
  "about.hero.title": "Building the Next-Gen Open Source Messaging Infrastructure",
  "about.hero.desc": "TupIM was founded by engineers with years of deep IM expertise, dedicated to making enterprise-grade instant messaging accessible to every developer at minimal cost. We believe communication is the foundation of every great application, and open source is the best way to make it better.",
  "about.hero.cta1": "Contact Us",
  "about.hero.cta2": "View on GitHub",

  "about.stat.devs": "Global Developers",
  "about.stat.msgs": "Messages / Day",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "Countries",

  "about.mission.label": "Mission & Vision",
  "about.mission.title": "Every App Deserves Powerful Messaging",
  "about.mission.p1": "IM technology has long been dominated by large players. Small teams wanting to add messaging to their product either had to depend on expensive SaaS services or spend huge resources building from scratch. TupIM was created to break this cycle.",
  "about.mission.p2": "We provide a complete open source IM solution — server, Web SDK, iOS SDK, and Android SDK — so teams of any size can integrate in hours, not months, while retaining full control of their data.",
  "about.mission.p3": "Our vision: to become the most trusted open source messaging infrastructure in the world, enabling hundreds of millions of users to communicate more securely and seamlessly through our technology.",

  "about.values.label": "Core Values",
  "about.values.title": "What We Believe In",
  "about.values.subtitle": "These values drive every technical decision and product direction we make.",
  "about.value.opensource.title": "Open & Transparent",
  "about.value.opensource.desc": "All code is fully open on GitHub under MIT license. No black boxes — the community can freely audit, contribute, and distribute.",
  "about.value.privacy.title": "Privacy First",
  "about.value.privacy.desc": "End-to-end encryption is standard, not optional. Private deployment means your data never touches a third party.",
  "about.value.performance.title": "Extreme Performance",
  "about.value.performance.desc": "Go-powered high-performance server handling millions of concurrent connections on a single node, battle-tested in production.",
  "about.value.community.title": "Community Driven",
  "about.value.community.desc": "Product direction is shaped by the community. Every issue and PR pushes us forward.",
  "about.value.developer.title": "Developer Experience",
  "about.value.developer.desc": "Rich docs, comprehensive demos, and clean SDK APIs make integration as smooth as possible.",
  "about.value.enterprise.title": "Enterprise Ready",
  "about.value.enterprise.desc": "Kubernetes clusters, multi-region HA, full monitoring and alerting — bulletproof for production workloads.",

  "about.timeline.label": "Milestones",
  "about.timeline.title": "Every Step We've Taken",
  "about.timeline.2020q1.date": "Q1 2020",
  "about.timeline.2020q1.title": "Project Kickoff",
  "about.timeline.2020q1.desc": "Core team formed, began researching and designing a high-performance IM server architecture built on Go.",
  "about.timeline.2020q3.date": "Q3 2020",
  "about.timeline.2020q3.title": "First Open Source Release",
  "about.timeline.2020q3.desc": "OpenIM Server v1.0 published on GitHub, garnering 500+ stars in the first week and attracting early contributors.",
  "about.timeline.2021q2.date": "Q2 2021",
  "about.timeline.2021q2.title": "Full Platform SDK Coverage",
  "about.timeline.2021q2.desc": "iOS, Android, and Web SDKs launched simultaneously — developers can integrate cross-platform IM in one step.",
  "about.timeline.2022q1.date": "Q1 2022",
  "about.timeline.2022q1.title": "10,000 GitHub Stars",
  "about.timeline.2022q1.desc": "Crossed 10K stars on GitHub, becoming one of the most popular open source IM projects in the Go ecosystem.",
  "about.timeline.2022q4.date": "Q4 2022",
  "about.timeline.2022q4.title": "Enterprise Edition Launched",
  "about.timeline.2022q4.desc": "Enterprise plans launched with private deployment, dedicated support, and SLA guarantees — serving the first enterprise clients.",
  "about.timeline.2023q2.date": "Q2 2023",
  "about.timeline.2023q2.title": "Audio & Video Module Live",
  "about.timeline.2023q2.desc": "WebRTC-based HD audio/video calling module officially integrated, supporting one-on-one and group calls.",
  "about.timeline.2024q1.date": "Q1 2024",
  "about.timeline.2024q1.title": "50,000 Global Developers",
  "about.timeline.2024q1.desc": "Over 50K developers using TupIM worldwide across 80+ countries, with daily message volume exceeding 200 million.",
  "about.timeline.2024q4.date": "Q4 2024",
  "about.timeline.2024q4.title": "TupIM Brand Upgrade",
  "about.timeline.2024q4.desc": "Full brand upgrade to TupIM — new website, new docs system, and a continued commitment to a better developer ecosystem.",

  "about.team.label": "Our Team",
  "about.team.title": "The People Behind TupIM",
  "about.team.subtitle": "A group of engineers who love open source and live and breathe IM technology.",
  "about.team.ceo.name": "Alex Chen",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "Former IM architect at a top-tier tech company with 10+ years of experience, led the design of systems handling millions of concurrent connections.",
  "about.team.cto.name": "Kevin Wang",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "Go core contributor and lead architect of OpenIM Server, deep expertise in high-concurrency distributed systems.",
  "about.team.lead.name": "Sophie Lin",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "Full-stack engineer owning the Web SDK and frontend architecture, active open source contributor and GitHub star project maintainer.",
  "about.team.sdk.name": "James Zhang",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "iOS & Android dual expert leading mobile SDK design, ensuring a consistent cross-platform development experience.",
  "about.team.infra.name": "David Liu",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "Kubernetes specialist responsible for TupIM's cloud-native and private deployment solutions, serving hundreds of enterprise clients.",
  "about.team.design.name": "Emma Wu",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "UX specialist focused on developer tooling — making even complex IM integrations feel smooth and delightful.",

  // Contact page
  "contact.badge": "Get in Touch",
  "contact.hero.title": "Questions? We're Here.",
  "contact.hero.desc": "Whether it's a technical issue, business inquiry, or media request — pick the channel that works best for you and we'll get back to you as soon as possible.",

  "contact.channel.support.title": "Technical Support",
  "contact.channel.support.desc": "Hit a bug, SDK issue, or deployment question? Open a GitHub issue or join our Slack community — our engineering team will help you out.",
  "contact.channel.support.link1": "Submit GitHub Issue",
  "contact.channel.support.link2": "Join Slack Community",

  "contact.channel.business.title": "Business Inquiries",
  "contact.channel.business.desc": "Interested in enterprise plans, commercial licensing, or custom development partnerships? Reach out to our business team.",
  "contact.channel.business.link1": "Send Business Email",
  "contact.channel.business.link2": "WeChat Consultation",

  "contact.channel.media.title": "Media & PR",
  "contact.channel.media.desc": "Press interviews, product reviews, or collaboration events? Contact our PR team — we'd love to work with you.",
  "contact.channel.media.link1": "Media Contact Email",
  "contact.channel.media.link2": "Follow on Twitter",

  "contact.channel.community.title": "Open Source Community",
  "contact.channel.community.desc": "Join our open source community, connect with developers worldwide, and stay up to date with the latest news and technical insights.",
  "contact.channel.community.link1": "Join Slack",
  "contact.channel.community.link2": "Follow on GitHub",

  "contact.response.note": "Typical response times: Technical issues within 24 hours · Business inquiries 1-2 business days · Media requests 2-3 business days",

  "contact.faq.label": "FAQ",
  "contact.faq.title": "Things You Might Want to Know",
  "contact.faq.f1.q": "Is TupIM completely free?",
  "contact.faq.f1.a": "Yes — TupIM server and all client SDKs are fully open source and free under the MIT license. Enterprise plans offer private deployment support, SLA guarantees, and dedicated technical services for a fee.",
  "contact.faq.f2.q": "How do I get started quickly with TupIM?",
  "contact.faq.f2.a": "Check our Quick Start docs. Deploy the server in 5 minutes with Docker Compose, then install the platform SDK via npm or CocoaPods to start building.",
  "contact.faq.f3.q": "How is data security and privacy ensured?",
  "contact.faq.f3.a": "TupIM supports private deployment — all data lives on your own servers and we have zero access to your user data. All messages use end-to-end encryption for secure transmission.",
  "contact.faq.f4.q": "What concurrency scale does it support?",
  "contact.faq.f4.a": "TupIM Server's Go-based architecture handles 1M+ concurrent connections on a single node. With Kubernetes horizontal scaling, it can handle any business scale.",
  "contact.faq.f5.q": "How do I get an enterprise license?",
  "contact.faq.f5.a": "Contact our sales team via business email or WeChat, describe your business scale and requirements, and we'll tailor the best plan and pricing for you.",

  // Navbar
  "nav.about": "About",
  "nav.contact": "Contact",

  // Page title
  "page.title": "TupIM — All-Round Privacy Protection with Private Chat | Group Chat | Secure Messages & More",
};


export default common;